(function() {
  'use strict';

  class ComparisonSlider extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    
    init() {
      this.slider = this.querySelector('.comparison-slider__input');
      this.overlay = this.querySelector('.comparison-slider__overlay');
      this.line = this.querySelector('.comparison-slider__line');
      this.overlayImg = this.querySelector('.comparison-slider__overlay img');
      
      if (!this.slider || !this.overlay || !this.line) {
        setTimeout(() => this.init(), 100);
        return;
      }
      
      // Supprimer les anciens event listeners s'ils existent
      this.removeEventListeners();
      
      // Créer les fonctions bound pour pouvoir les supprimer plus tard
      this.handleInput = this.handleInput.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.handleMouseDown = this.handleMouseDown.bind(this);
      this.handleMouseUp = this.handleMouseUp.bind(this);
      this.handleResize = this.handleResize.bind(this);
      
      // Ajouter les event listeners
      this.slider.addEventListener('input', this.handleInput);
      this.slider.addEventListener('touchstart', this.handleTouchStart);
      this.slider.addEventListener('touchend', this.handleTouchEnd);
      this.slider.addEventListener('mousedown', this.handleMouseDown);
      this.slider.addEventListener('mouseup', this.handleMouseUp);
      window.addEventListener('resize', this.handleResize);
      
      // Ajuster la largeur de l'image sur mobile
      this.adjustImageWidth();
      
      // Initialiser la position
      this.updateSlider(this.slider.value || 50);
    }
    
    adjustImageWidth() {
      if (this.overlayImg && window.innerWidth <= 768) {
        const containerWidth = this.offsetWidth;
        this.overlayImg.style.width = containerWidth + 'px';
        this.style.setProperty('--slider-width', containerWidth + 'px');
      }
    }
    
    handleResize() {
      this.adjustImageWidth();
    }
    
    removeEventListeners() {
      if (this.slider && this.handleInput) {
        this.slider.removeEventListener('input', this.handleInput);
        this.slider.removeEventListener('touchstart', this.handleTouchStart);
        this.slider.removeEventListener('touchend', this.handleTouchEnd);
        this.slider.removeEventListener('mousedown', this.handleMouseDown);
        this.slider.removeEventListener('mouseup', this.handleMouseUp);
        window.removeEventListener('resize', this.handleResize);
      }
    }
    
    handleInput(e) {
      this.updateSlider(e.target.value);
    }
    
    handleTouchStart() {
      this.classList.add('dragging');
    }
    
    handleTouchEnd() {
      this.classList.remove('dragging');
    }
    
    handleMouseDown() {
      this.classList.add('dragging');
    }
    
    handleMouseUp() {
      this.classList.remove('dragging');
    }
    
    updateSlider(value) {
      const percentage = value + '%';
      
      if (this.overlay) {
        this.overlay.style.width = percentage;
      }
      
      if (this.line) {
        this.line.style.left = percentage;
      }
    }
    
    disconnectedCallback() {
      this.removeEventListeners();
    }
  }

  // Enregistrer le custom element seulement s'il n'existe pas déjà
  if (!customElements.get('comparison-slider')) {
    customElements.define('comparison-slider', ComparisonSlider);
  }

  // Fonction d'initialisation
  function initializeSliders() {
    const sliders = document.querySelectorAll('comparison-slider');
    sliders.forEach(slider => {
      if (!slider.initialized) {
        slider.initialized = true;
      }
    });
  }

  // Initialiser au chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSliders);
  } else {
    initializeSliders();
  }

  // Réinitialiser après les changements Shopify
  document.addEventListener('shopify:section:load', initializeSliders);
  document.addEventListener('shopify:section:reorder', initializeSliders);
  window.addEventListener('load', initializeSliders);

})();